import { Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

interface Props {
  data: { type: string; count: number }[];
}

const colorMap: Record<string, string> = {
  active: '#48BB78',
  trial: '#4299E1',
  cancelled: '#FC8181',
  expired: '#A0AEC0',
  pending: '#ECC94B',
  trial_expired: '#CBD5E0',
};

export default function SubscriptionBreakdownCard({ data }: Props) {
  const { t } = useTranslation();
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const labels = data.map((d) => d.type);
  const series = data.map((d) => d.count);
  const colors = data.map((d) => colorMap[d.type] || '#A0AEC0');

  return (
    <Card p="20px" flex="1" minW="300px">
      <Text color={textColor} fontSize="lg" fontWeight="700" mb="10px">
        {t('dashboard.subscription_breakdown')}
      </Text>
      {series.length > 0 ? (
        <ReactApexChart
          type="donut"
          series={series}
          options={{
            labels,
            colors,
            legend: { position: 'bottom' },
            dataLabels: { enabled: true },
          }}
          height={280}
        />
      ) : (
        <Text color="gray.400">{t('dashboard.no_data')}</Text>
      )}
    </Card>
  );
}
